export enum ContributionRateCalculationType {
  Percent = 1,
  PercentRange = 2,
  YMPEIntegratedPercent = 3,
  NA = 4
}
